<template>
  <div id="mergeTagList">
    <v-toolbar color="grey lighten-3" height="40">
      <v-toolbar-title :class="titlePadding">Special Links</v-toolbar-title>
    </v-toolbar>
    <v-text-field
      @keydown.native.escape="specialLinkSearch=''"
      v-model="specialLinkSearch"
      label="Search"
      hint="Filter Special Links"
      persistent-hint
      clearable
      single-line
      :class="searchPadding"
    >
    </v-text-field>
    <v-list :class="listPadding" shaped dense>
      <v-list-item v-for="(sLink, i) in filteredSpecialLinks" :key="i" @click="copy(sLink.link)">
        <v-list-item-content><v-list-item-title>{{ sLink.label }}</v-list-item-title></v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { CopyTextMixin } from '@/components/mixins'
import SidebarPropsMixin from './SidebarPropsMixin'

export default {
  name: 'special-links-sidebar',
  mixins: [CopyTextMixin, SidebarPropsMixin],
  components: {},
  data: function () {
    return {
      specialLinkSearch: ''
    }
  },
  computed: {
    ...mapState('EmailTemplateStore', ['specialLinks']),
    filteredSpecialLinks () {
      if (!this.specialLinkSearch) {
        return this.specialLinks
      }
      let result = this.specialLinks.filter(row => {
        let isIncluded = false
        if (row.label.toLowerCase().includes(this.specialLinkSearch.toLowerCase())) {
          isIncluded = true
        } else if (row.link.toLowerCase().includes(this.specialLinkSearch.toLowerCase())) {
          isIncluded = true
        }
        return isIncluded
      })
      return result
    }
  }
}
</script>
